import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { DEVICE_SIZE, mq } from '../utils/mq';

import { useLinkComponent } from '../utils/component';
// import { useStickyContext } from '../utils/sticky';

const Container = styled.div`
  background-color: var(--theme-palette-red);
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  bottom: -1px;
  box-shadow: 0px 0px 30px 0px #0000001a;
  color: var(--theme-palette-white);
  align-items: center;
  display: flex;
  font-weight: bold;
  gap: 20px;
  margin: 0 auto;
  max-width: 1170px;
  padding: 0px 30px;
  position: fixed;
  width: 100%;
  z-index: 1000000;

  ${(props) =>
    props.className === 'bottomNav' &&
    mq.lte(
      DEVICE_SIZE.LARGE,
      css`
        bottom: 57px;
      `,
    )}

  @media only screen and (max-width: 1000px) {
    gap: 12px;
    margin-left: calc(-1 * var(--spacer-s));
  }
`;

const Description = styled.span`
  font-size: 14px;
  font-weight: bold;
  line-height: 1.38;
  padding: var(--spacer-xs) 0;
`;

const Price = styled.span`
  font-family: var(--theme-typography-primary-font);
  font-size: 26px;
  font-weight: bold;
  margin: auto;

  @media only screen and (max-width: 1000px) {
    font-size: 18px;
  }
`;

const Column = styled.div`
  margin-left: auto;

  @media only screen and (max-width: 1000px) {
    margin: auto;
    min-width: initial;
  }
`;

const LinkTitle = styled.div`
  align-items: center;
  background-color: var(--theme-palette-red);
  border: solid 2px var(--theme-palette-red);
  border-radius: 6px;
  display: flex;
  font-weight: bold;
  gap: 8px;
  justify-content: center;
  margin: auto;
  padding: 8px 10px;
  position: relative;
  transition: background-color 0.3s, border-color 0.3s;
  width: fit-content;
  white-space: nowrap;

  &:hover {
    background-color: var(--theme-palette-dark-red);
    border: solid 2px var(--theme-palette-dark-red);
  }

  @media only screen and (max-width: 767px) {
    min-width: auto;
  }
`;

const SvgShop = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border: 3px solid white;
  border-radius: 10px;
`;

const LinkName = styled.span`
  color: white;
  font-family: var(--theme-typography-default-font);

  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

const Svg = styled.svg`
  height: 30px;
  min-width: 30px;
  width: 30px;
  fill: var(--theme-palette-white);
`;
const CloseSvg = styled.svg`
  background: ${(props) => (props.theme.isDark ? 'black' : 'white')};
  border: 1px solid #ddd;
  border-radius: 50%;
  height: 24px;
  min-width: 24px;
  position: relative;
  width: 24px;

  @media only screen and (max-width: 768px) {
    position: absolute;
    right: var(--spacer-s);
    top: -12px;
  }
`;

type Props = {
  name?: string;
  price?: string;
  landingPage?: string;
  button?: string;
  svg?: { elements: string; viewBox: string };
  trackEvent: (obj: any) => any;
  className?: string;
};

export function StickyComponent({ name, price, landingPage, button, svg, trackEvent, className }: Props) {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  // const { setSticky } = useStickyContext();
  // setSticky(true);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 350) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCTAClick = () => {
    const userToken = localStorage.getItem('actionToken');
    trackEvent({
      variables: {
        userToken,
        eventCategory: 'Sponso',
        eventName: 'click_sticky_footer',
        actionName: 'click_sticky_footer',
        eventValue: JSON.stringify({ product: name, price: price ?? null, marchand: null, position: null }),
        customDimensions: [],
        customVariables: [],
        url: document.location.href,
      },
    });
  };

  const handleCloseClick = (event: any) => {
    event.preventDefault();
    setIsClosed(true);
  };

  const LinkComponent = useLinkComponent();

  return (
    <div>
      {isVisible && !isClosed && (
        <LinkComponent href={landingPage} rel={['nofollow']} openInNewWindow onClick={handleCTAClick}>
          <Container className={className}>
            {svg && <Svg viewBox={svg?.viewBox} dangerouslySetInnerHTML={{ __html: svg.elements }} />}
            <Description>{name}</Description>
            {price && <Price>{price}</Price>}
            <Column>
              <LinkTitle>
                <LinkName>{button}</LinkName>
                <SvgShop>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="25px"
                    viewBox="0 -960 960 960"
                    width="25px"
                    fill="#ffffff"
                  >
                    <path d="M280-80q-33 0-56.5-23.5T200-160q0-33 23.5-56.5T280-240q33 0 56.5 23.5T360-160q0 33-23.5 56.5T280-80Zm400 0q-33 0-56.5-23.5T600-160q0-33 23.5-56.5T680-240q33 0 56.5 23.5T760-160q0 33-23.5 56.5T680-80ZM246-720l96 200h280l110-200H246Zm-38-80h590q23 0 35 20.5t1 41.5L692-482q-11 20-29.5 31T622-440H324l-44 80h440q17 0 28.5 11.5T760-320q0 17-11.5 28.5T720-280H280q-45 0-68-39.5t-2-78.5l54-98-144-304H80q-17 0-28.5-11.5T40-840q0-17 11.5-28.5T80-880h65q11 0 21 6t15 17l27 57Zm134 280h280-280Z" />
                  </svg>
                </SvgShop>
              </LinkTitle>
            </Column>
            <CloseSvg onClick={handleCloseClick} width="24px" height="24px" viewBox="0 0 24 24">
              <g>
                <path
                  fill="var(--color-alt-7)"
                  fillRule="nonzero"
                  d="M13.5 12l3.344 3.375a.416.416 0 0 1 .156.344c0 .146-.052.26-.156.344l-.782.78a.416.416 0 0 1-.343.157.416.416 0 0 1-.344-.156L12 13.5l-3.375 3.344a.416.416 0 0 1-.344.156.416.416 0 0 1-.344-.156l-.78-.781A.416.416 0 0 1 7 15.719c0-.146.052-.26.156-.344L10.5 12 7.156 8.625A.416.416 0 0 1 7 8.281c0-.146.052-.26.156-.343l.781-.782A.416.416 0 0 1 8.281 7c.146 0 .26.052.344.156L12 10.5l3.375-3.344A.416.416 0 0 1 15.719 7c.146 0 .26.052.343.156l.782.782A.416.416 0 0 1 17 8.28c0 .146-.052.26-.156.344L13.5 12z"
                />
              </g>
            </CloseSvg>
          </Container>
        </LinkComponent>
      )}
    </div>
  );
}
